import React from "react";

const Facebook = () => {
  return (
    <a
      href="https://www.facebook.com/duchaidev/"
      target="_blank"
      className="group px-[7px] py-1"
      rel="noreferrer"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        // fill="#fff"
        className="transition-all duration-300 group-hover:fill-green-300 fill-white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M26.0003 13.0796C26.0003 5.85488 20.1796 -0.00161743 13.0003 -0.00161743C5.81782 7.56844e-06 -0.00292969 5.85488 -0.00292969 13.0813C-0.00292969 19.6089 4.75182 25.0201 10.9658 26.0016V16.861H7.66707V13.0813H10.9691V10.1969C10.9691 6.91926 12.9109 5.10901 15.8798 5.10901C17.3033 5.10901 18.7902 5.36413 18.7902 5.36413V8.58163H17.1506C15.5369 8.58163 15.0332 9.59076 15.0332 10.6259V13.0796H18.6374L18.0622 16.8594H15.0316V26C21.2456 25.0185 26.0003 19.6073 26.0003 13.0796Z" />
      </svg>
    </a>
  );
};

export default Facebook;
